import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import { getAspectRatioHeight } from '../../../lib/Media';
import ContentCover from '../../Content/ContentCover';
import { getNumericSpacing } from '../../../lib/Styles';

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
  },
  rounded: {
    borderRadius: theme.spacing(1),
    boxShadow: 'inset 0px 0px 0px 1px var(--cover-box-shadow)',
  },
}));

export type RoomContentWrapperProps = React.PropsWithChildren<{
  cover?: string;
  disableDefaultCover?: boolean;
  disableMinHeight?: boolean;
  rounded?: boolean;
  width?: number | null;
  setAutoPlay?: (autoPlay: boolean) => void;
}>;

const RoomContentWrapper = React.forwardRef<
  HTMLDivElement,
  RoomContentWrapperProps
>((props: RoomContentWrapperProps, ref): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();

  const {
    children,
    cover,
    disableDefaultCover = false,
    disableMinHeight = false,
    rounded,
    width,
    setAutoPlay,
  } = props;

  const [hideCover, setHideCover] = useState(
    cover === undefined || disableDefaultCover
  );

  let minHeight: number | undefined;
  if (!disableMinHeight) {
    minHeight = width
      ? getAspectRatioHeight(width)
      : getNumericSpacing(theme, 44);
  }

  const onCoverClicked = () => {
    setHideCover(true);
    setAutoPlay?.(true);
  };

  const renderContent = (): JSX.Element => {
    if (hideCover) {
      return <>{children}</>;
    }

    return (
      <ContentCover
        clickable
        cover={cover}
        onClick={onCoverClicked}
        playButton
      />
    );
  };

  return (
    <Box
      className={classNames(classes.box, {
        [classes.rounded]: rounded,
      })}
      style={{ minHeight }}
      {...{ ref }}
    >
      {renderContent()}
    </Box>
  );
});

export default RoomContentWrapper;
